import React from 'react';
import { Box, Paper, Typography, Button, Divider, Grid, Chip } from '@mui/material';
import LinkOrdine from '../LinkOrdine';
import { MoreVert } from '@mui/icons-material';
import DefaultPaginator from '../../../paginator/DefaultPaginator';
import __t from '../../../../lib/traduzioni';
import useBSSLogger from '../../../../hooks/useBSSLogger';
import { Masonry } from '@mui/lab';

const {logger} = useBSSLogger;

const StoricoOrdiniMasonry = ({listaOrdini, stati, Paginator = DefaultPaginator, page, npagine, cambiaPagina, statoMenu, setStatoMenu, dialogDuplica, setDialogDuplica}) => {

    return (
        <Box>
            <Masonry columns={[1, 1, 2]} spacing={[1, 1, 2]}>
                {listaOrdini.map((ordine) => {

                    const stileStato = {
                        color: ordine.statoordine.coloretesto,
                        backgroundColor: ordine.statoordine.colorestato,
                        fontWeight: "bold"
                    }

                    return (
                        <Paper key={ordine.id} elevation={3} sx={{
                            "& ::selection": stileStato, 
                            borderRadius: 2, 
                            border: `thin solid ${stileStato.backgroundColor}`,
                            padding: 2

                        }}>
                            <Typography variant="body1">
                                <Grid container spacing={1} columns={12}>                               
                                    <Grid item xs={12} sx={{textAlign: "right"}}>
                                        <Button sx={{minWidth: 0, color: stileStato.backgroundColor}} onClick={e => setStatoMenu({anchorEl: e.currentTarget, open: true, ordine})}>
                                            <MoreVert />
                                        </Button>
                                    </Grid> 
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item xs={4} sx={{textAlign: "right"}}>
                                        {__t("numordine")}
                                    </Grid>                                
                                    <Grid item xs={8} sx={{fontWeight: "bold", textAlign: "right"}}>
                                        <LinkOrdine ordine={ordine} />
                                    </Grid>
                                    <Grid item xs={4} sx={{textAlign: "right"}}>
                                        {__t("tracking")}
                                    </Grid>                                
                                    <Grid item xs={8} sx={{fontWeight: "bold", textAlign: "right"}}>
                                        <LinkOrdine ordine={ordine} ordineLabel={__t("tracking")} />
                                    </Grid>  
                                    <Grid item xs={4} sx={{textAlign: "right"}}>
                                        {__t("mittente")}
                                    </Grid>                                
                                    <Grid item xs={8} sx={{fontWeight: "bold", textAlign: "right"}}>
                                        {ordine.indirizzomittente.contattare}
                                    </Grid> 
                                    <Grid item xs={4} sx={{textAlign: "right"}}>
                                        {__t("destinatario")}
                                    </Grid>                                
                                    <Grid item xs={8} textAlign={"right"} sx={{fontWeight: "bold"}}>
                                        {ordine.indirizzodestinatario.contattare}
                                    </Grid>                                     
                                    <Grid item xs={4} sx={{textAlign: "right"}}>
                                        {__t("statoordine")}
                                    </Grid>                                
                                    <Grid item xs={8} sx={{fontWeight: "bold", textAlign: "right"}}>
                                        <Chip sx={{...stileStato}} label={ordine.statoordine.codicestato} />     
                                    </Grid>                                     
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item xs={4} sx={{textAlign: "right"}}>
                                        {__t("totale")}
                                    </Grid>                                                                    
                                    <Grid item xs={8} sx={{fontWeight: "bold", textAlign: "right"}}>
                                        <Typography variant={"h5"}>
                                            € {ordine.totaleivato.toFixed(2)}
                                        </Typography>
                                    </Grid>                                    
                                </Grid>
                            </Typography>
                            
                        </Paper>
                    )

                })}
                                
            </Masonry>
            {(npagine > 1) && 
                Paginator({page, npagine, cambiaPagina}) 
            } 
        </Box>
        
    )
}

export default StoricoOrdiniMasonry;